import React, { useReducer, useEffect, useMemo, useState } from "react";
import ReactDOM from "react-dom";
import eventBus from "../../../../../util/eventBus";
import { getReactComponent } from "../../../../../util/reactComponent";
import {
  Table,
  Icon,
  Radio,
  InputNumber,
  Rate,
  Space,
} from "@kdcloudjs/kdesign";
import "@kdcloudjs/kdesign/dist/kdesign.css";
import "./main.less";

(function (KDApi) {
  const setHtml = function (model, primaryProps, { I18N }) {
    KDApi.loadFile("./css/index.css", model, () => {
      function Item(props) {
        console.log(props);
        const {
          topGroupName,
          topGroupId,
          fieldList,
          capItems: dataSource,
        } = props?.data;
        const isEdit = props.isEdit;
        const [checkedData, setCheckedData] = useState(
          props?.data?.capItems || []
        );

        const [expandStatus, setExpandStatus] = React.useState({
          selfAssess: false,
        });

        console.log(expandStatus, "expandStatus");

        const onChangeExtendStatus = (curStatus, changeValue) => {
          setExpandStatus((state) => ({ ...state, ...curStatus }));
        };

        const changeCurrentValue = (rowIndex, value) => {
          console.log(rowIndex, value);
          props.changeCurrentValue(rowIndex, value);
        };

        const getDefinationWidth = () => {
          let max = 0;
          dataSource &&
            dataSource.length &&
            dataSource.forEach(({ defination }) => {
              if (defination && defination?.length > max) {
                max = defination.length;
              }
            });
          max = max * 2;
          return max > 600 ? 600 : max < 300 ? 300 : max;
        };

        const columns = fieldList.map(({ code, name, children }) => {
          const otherProps = children
            ? {
                features: {
                  showExtendIcon: true,
                },
                children: children.map((item) => {
                  return {
                    title: (
                      <div title={item.name} className="single-line">
                        {item.name}
                      </div>
                    ),
                    name: item.name,
                    code: item.code,
                    align: "left",
                    width:
                      item.code === "selfAssSum"
                        ? 200
                        : item.code === "selfAssResType"
                        ? 300
                        : 100,
                    render:
                      item.code === "selfAssResType"
                        ? (curData, record, rowIndex) => {
                            const {
                              reviewType,
                              decimal,
                              scoreLow,
                              scoreHigh,
                              optionTags,
                              currentValue,
                              starTags,
                            } = curData;
                            // 10单选 20输入计分 30打星
                            if (reviewType === "10") {
                              if ("selfAssResTop" === code) {
                                return optionTags[0].name;
                              }
                              return (
                                <Radio.Group
                                  className={isEdit ? "" : "disabled-column"}
                                  value={currentValue}
                                >
                                  {optionTags.map(({ name, value }) => (
                                    <Radio key={value} value={value}>
                                      {name}
                                    </Radio>
                                  ))}
                                </Radio.Group>
                              );
                            } else if (reviewType === "20") {
                              return (
                                <Space
                                  className={isEdit ? "" : "disabled-column"}
                                >
                                  <InputNumber
                                    zeroShow={true}
                                    showDecimalTailZero={true}
                                    style={{ maxWidth: 100 }}
                                    borderType="bordered"
                                    // min={scoreLow}
                                    // max={scoreHigh}
                                    status={
                                      currentValue > scoreHigh ||
                                      currentValue < scoreLow
                                        ? "error"
                                        : ""
                                    }
                                    value={currentValue}
                                    decimalLength={decimal - 0}
                                  />
                                  {(currentValue > scoreHigh ||
                                    currentValue < scoreLow) && (
                                    <div style={{ color: "red" }}>
                                      {I18N("optional_values")}: {`[${scoreLow}, ${scoreHigh}]`}
                                    </div>
                                  )}
                                </Space>
                              );
                            } else if (reviewType === "30") {
                              return (
                                <Space
                                  className={isEdit ? "" : "disabled-column"}
                                >
                                  <Rate
                                    disabled={true}
                                    count={starTags.length}
                                    allowHalf={false}
                                    value={currentValue}
                                  />
                                  <div>
                                    {
                                      starTags.find(
                                        (starTag) =>
                                          starTag.value == currentValue
                                      )?.name
                                    }
                                  </div>
                                </Space>
                              );
                            }
                            return currentValue;
                          }
                        : (value, record, rowIndex) => {
                            return item.code === "fileNum" ? (
                              <div
                                className={
                                  value == 0
                                    ? "attachment-wrapper attachment-wrapper-disabled"
                                    : "attachment-wrapper"
                                }
                                onClick={() => {
                                  if (value == 0) return;
                                  model.invoke(
                                    "downloadSelfAssFile",
                                    record.itemId
                                  );
                                }}
                              >
                                <Icon type="attachment" />
                                {value}
                              </div>
                            ) : (
                              value
                            );
                          },
                  };
                }),
              }
            : code === "itemName"
            ? {
                render: (value, record) => (
                  <div
                    style={{ color: "#0e5fd8", cursor: "pointer" }}
                    onClick={() =>
                      model.invoke("viewItemDetail", record.itemId)
                    }
                  >
                    {value}
                  </div>
                ),
              }
            : code === "fileNumTop"
            ? {
                width: 200,
                render: (value, record, rowIndex) => {
                  return (
                    <div
                      className={
                        value == 0
                          ? "attachment-wrapper attachment-wrapper-disabled"
                          : "attachment-wrapper"
                      }
                      onClick={() => {
                        if (value == 0) return;
                        model.invoke("downloadSelfAssFileTop", record.itemId);
                      }}
                    >
                      <Icon type="attachment" />
                      {value}
                    </div>
                  );
                },
              }
            : ["reviewType", "selfAssResTop", "reviewHistoryType"].includes(
                code
              )
            ? {
                width: 300,
                render: (curData, record, rowIndex) => {
                  const {
                    reviewType,
                    decimal,
                    scoreLow,
                    scoreHigh,
                    optionTags,
                    currentValue,
                    starTags,
                  } = curData;
                  // 10单选 20输入计分 30打星
                  if (reviewType === "10") {
                    if ("selfAssResTop" === code) {
                      return optionTags[0].name;
                    }
                    return (
                      <Radio.Group
                        className={isEdit ? "" : "disabled-column"}
                        value={currentValue}
                        onChange={(_, v) => changeCurrentValue(rowIndex, v)}
                      >
                        {optionTags.map(({ name, value }) => (
                          <Radio key={value} value={value}>
                            {name}
                          </Radio>
                        ))}
                      </Radio.Group>
                    );
                  } else if (reviewType === "20") {
                    return (
                      <Space className={isEdit ? "" : "disabled-column"}>
                        <InputNumber
                          zeroShow={true}
                          showDecimalTailZero={true}
                          style={{ maxWidth: 100 }}
                          borderType="bordered"
                          // min={scoreLow}
                          // max={scoreHigh}
                          status={
                            currentValue > scoreHigh || currentValue < scoreLow
                              ? "error"
                              : ""
                          }
                          value={currentValue}
                          onChange={(e) => {
                            changeCurrentValue(rowIndex, e.target.value);
                          }}
                          decimalLength={decimal - 0}
                        />
                        {(currentValue > scoreHigh ||
                          currentValue < scoreLow) && (
                          <div style={{ color: "red" }}>
                            {I18N("optional_values")}: {`[${scoreLow}, ${scoreHigh}]`}
                          </div>
                        )}
                      </Space>
                    );
                  } else if (reviewType === "30") {
                    return (
                      <Space className={isEdit ? "" : "disabled-column"}>
                        <Rate
                          disabled={[
                            "selfAssResTop",
                            "reviewHistoryType",
                          ].includes(code)}
                          count={starTags.length}
                          allowHalf={false}
                          value={currentValue}
                          onChange={(value) => {
                            if (
                              ["selfAssResTop", "reviewHistoryType"].includes(
                                code
                              )
                            ) {
                              return;
                            }
                            changeCurrentValue(rowIndex, value);
                          }}
                        />
                        <div>
                          {
                            starTags.find(
                              (starTag) => starTag.value == currentValue
                            )?.name
                          }
                        </div>
                      </Space>
                    );
                  }
                  return currentValue;
                },
              }
            : {};
          return {
            title:
              code === "reviewType" ? (
                <div className="single-line" title={name}>
                  <Icon
                    type="star"
                    style={{
                      color: "red",
                      marginRight: "5px",
                      marginBottom: "5px",
                      fontSize: "12px",
                      transform: "scale(0.8)",
                    }}
                  />
                  {name}
                </div>
              ) : (
                <div title={name} className="single-line">
                  {name}
                </div>
              ),

            code,
            name,
            width: children
              ? 400
              : code === "itemGroupLongName"
              ? 200
              : code === "defination"
              ? getDefinationWidth()
              : 100,
            align: "left",
            ...otherProps,
          };
        });
        const isExpend = useMemo(
          () =>
            Object.keys(expandStatus).filter(
              (key) => expandStatus[key] === true
            )?.length,
          [expandStatus]
        );

        const special = fieldList.find(({ code }) => code === "fileNum");
        return (
          <div className="exa">
            <div className="examine-header">{topGroupName}</div>
            <Table
              className={isExpend ? "expend-table" : "unexpend-table"}
              useOuterBorder={false}
              dataSource={dataSource}
              columns={columns}
              columnGroupExtend={{
                extendStatus: expandStatus,
                onChangeExtendStatus: onChangeExtendStatus,
              }}
            />
          </div>
        );
      }
      const Root = (props) => {
        const [store, setStore] = useState({
          model: props?.model,
          customProps: props?.customProps,
          data: props?.customProps?.data?.data, // 所有数据
          isEdit: props?.customProps?.data?.pageStatus === "edit", // 组件状态  edit or  view
          I18N: props?.I18N,
        });
        console.log(store, "---store---");

        useEffect(() => {
          const updateSub = eventBus.sub(model, "update", (customProps) => {
            const isEdit = customProps?.data?.pageStatus === "edit";
            const data = customProps?.data?.data;
            setStore((state) => ({ ...state, data, isEdit }));
          });
          return () => {
            eventBus.unsub(updateSub);
          };
        }, []);
        const checkErrorBeforeSubmit = () => {
          store.data.capItems.find(({ reviewType }) => {
            const {
              reviewType: type,
              scoreHigh,
              scoreLow,
              currentValue,
            } = reviewType;
            return (
              (currentValue > scoreHigh || currentValue < scoreLow) &&
              type === "20"
            );
          });
        };
        const changeCurrentValue = (index, rowIndex, value) => {
          const newData = [...data];
          newData[index].capItems[rowIndex].reviewType.currentValue = value;
          setStore((state) => ({ ...state, data: newData }));

          const {
            reviewType: type,
            scoreHigh,
            scoreLow,
            currentValue,
          } = newData[index].capItems[rowIndex].reviewType;

          if (
            (currentValue > scoreHigh || currentValue < scoreLow) &&
            type === "20"
          ) {
            console.log("超出范围了");
            // 超出范围了 不进行数据传输保存
          } else {
            model.invoke("changeCurrentValue", {
              itemId: newData[index].capItems[rowIndex].itemId,
              value,
            });
          }
        };
        console.log(store);
        const { isEdit, data } = store;
        return (
          <div
            className={
              isEdit
                ? "qualification-examine-container"
                : " qualification-examine-container qualification-examine-container-view"
            }
          >
            <div className="qualification-examine-warpper">
              {data && data.length
                ? data.map((item, index) => (
                    <Item
                      key={item.topGroupId}
                      data={item}
                      isEdit={isEdit}
                      changeCurrentValue={(rowIndex, value) =>
                        changeCurrentValue(index, rowIndex, value)
                      }
                    ></Item>
                  ))
                : null}
            </div>
          </div>
        );
      };

      ReactDOM.render(
        <Root model={model} customProps={primaryProps} I18N={I18N} />,
        model.dom
      );
    });
  };

  const ReactComponent = getReactComponent(setHtml);

  // 注册自定义组件
  KDApi.register("examine", ReactComponent, { isMulLang: true });
})(window.KDApi);
